export * from './workflow-designer-vertex-properties.component';
export * from './workflow-designer-vertex-connection.component';



// WEBPACK FOOTER //
// ./src/library/designer/vertex/index.ts